export default __webpack_public_path__ + "static/spending-1b880219cb2c8c5aa5bf73a138ffc529.webp";